const module = { name: 'movie/shared/mop.viewToggleBtns', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { global_consts as global_consts_MOPViewTypes } from 'require-core';

const { MOPViewTypes } = global_consts_MOPViewTypes;


import { Fandango_adobeLaunch as adobeLaunch } from 'require-global';



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile }, featureFlags: { mopTabsEnabled } } } = Fandango_context;


import { default as bannerMPS } from 'swug-fdRequire-call:movie/shared/bannerMPS';



const Selectors = {
    BTNS: '.js-viewing-type-toggle-btn',
    DESKTOP_ON_DEMAND_WRAPPER: '#on-demand-desktop-wrapper',
    FAN_ALERT_FORM: '#fanalert-form',
    FAN_ALERT_SECTION: '#new-fan-alert',
    FAN_ALERT_FORM_EXPOSED: '#fanalert-form-exposed',
    FUTURE_DATE_NOTICE: '#future-date-notice',
    GLOBAL_TOOLTIP_BUY_TICKETS: `.global-tooltip__container--mop-mobile-buy-tickets`,
    GLOBAL_TOOLTIP_WATCH_AT_HOME: `.global-tooltip__container--mop-mobile-at-home`,
    IN_THEATERS_CONTAINER: '#in-theaters-container',
    ON_DEMAND_AD_UNIT: '.js-on-demand-adunit',
    ON_DEMAND_DETAILS: '#on-demand-details',
    PLACEHOLDER: '#viewing-type-toggle-placeholder',
    TABS: '.js-viewing-type-toggle-item',
    VIEWING_TYPE_TOGGLE_WRAPPER: '.viewing-type-toggle__wrapper',
    VIEWING_TYPE_TOGGLE_WRAPPER_MWEB: '.viewing-type-toggle__wrapper--mweb',
    VIEWING_TYPE_TOGGLE_STICKY: '.viewing-type-toggle__sticky',
    WRAPPER: '#viewing-type-toggle-wrapper',
}


const Styles = {
    ACTIVE_TAB: 'viewing-type-toggle__item--active',
    HIDE: 'hide',
    HIDE_TOGGLE: 'viewing-type-toggle__hide',
    STICK_TOGGLE: 'is-stuck',
    MOBILE_TABS: 'mobile-tabs',
}


let currentTab


let stickyObserver = null
function toggleView(type, all = false, mopTabsEnabled = true) {
    const inTheaters = type === MOPViewTypes.IN_THEATERS || all;
    const onDemand = type === MOPViewTypes.ON_DEMAND || all;
    $(Selectors.IN_THEATERS_CONTAINER).toggleClass(Styles.HIDE_TOGGLE, !inTheaters);
    $(Selectors.FAN_ALERT_FORM).toggleClass(Styles.HIDE_TOGGLE, !inTheaters);
    $(Selectors.FAN_ALERT_FORM_EXPOSED).toggleClass(Styles.HIDE_TOGGLE, !inTheaters);
    $(Selectors.FAN_ALERT_SECTION).toggleClass(Styles.HIDE_TOGGLE, !inTheaters);
    $(Selectors.FUTURE_DATE_NOTICE).toggleClass(Styles.HIDE_TOGGLE, !inTheaters);
    $(Selectors.GLOBAL_TOOLTIP_BUY_TICKETS).toggleClass(Styles.HIDE_TOGGLE, !inTheaters);
    $(Selectors.GLOBAL_TOOLTIP_WATCH_AT_HOME).toggleClass(Styles.HIDE_TOGGLE, !onDemand);
    $(isMobile ? Selectors.ON_DEMAND_DETAILS : Selectors.DESKTOP_ON_DEMAND_WRAPPER).toggleClass(Styles.HIDE_TOGGLE, !onDemand);
    if (isMobile && onDemand && mopTabsEnabled) {
        $(Selectors.ON_DEMAND_AD_UNIT).removeClass(Styles.HIDE);
        bannerMPS.displayBannerMidAd();
    }
    else {
        $(Selectors.ON_DEMAND_AD_UNIT).addClass(Styles.HIDE);
    }
}
function selectTab(tab) {
    const map = {
        [MOPViewTypes.IN_THEATERS]: MOPViewTypes.ON_DEMAND,
        [MOPViewTypes.ON_DEMAND]: MOPViewTypes.IN_THEATERS,
    };
    currentTab = tab;
    const activeIconAttr = isMobile ? 'iconActiveMobile' : 'iconActive';
    const thisTabEl = $(`${Selectors.TABS}[data-tab=${tab}]`);
    const otherTabEl = $(`${Selectors.TABS}[data-tab=${map[tab]}]`);
    const thisIcon = thisTabEl.find('[data-icon]');
    const otherIcon = otherTabEl.find('[data-icon]');
    thisTabEl.addClass(Styles.ACTIVE_TAB).attr('aria-checked', true);
    otherTabEl.removeClass(Styles.ACTIVE_TAB).attr('aria-checked', false);
    thisIcon.addClass(thisIcon.data(activeIconAttr)).removeClass(thisIcon.data('icon'));
    otherIcon.addClass(otherIcon.data('icon')).removeClass(otherIcon.data(activeIconAttr));
    toggleView(tab);
}
function init(results) {
    const { movie: { defaultTab, releaseDate }, movieAttribs: { startDate }, movieState: { isNotTicketingWindow, isPreRelease, isTicketingWindow }, } = results;
    const showStreaming = false;
    const date = releaseDate || startDate;
    const showInTheaters = isTicketingWindow || startDate || !isNotTicketingWindow || (isPreRelease && date);
    let icon;
    let text;
    if (!mopTabsEnabled) {
        if (showStreaming) {
            toggleView(null, true, mopTabsEnabled);
        }
        return;
    }
    if (showInTheaters && date) {
        if (!showStreaming) {
            toggleView(MOPViewTypes.IN_THEATERS);
        }
    }
    else if (showStreaming) {
        toggleView(MOPViewTypes.ON_DEMAND);
    }
    else {
        icon = 'icon-clapper-board';
        text = 'Not available at home or in cinemas.';
    }
    const showTabs = showInTheaters && showStreaming;
    const viewModel = {
        bin: icon && text ? { icon, text } : null,
        onDemandTabText: 'Watch at Home',
        showTabs,
    };
    if (!showTabs && !viewModel.bin) {
        const section = isMobile ? $(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER_MWEB) : $(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER);
        section.length > 0 && section.hide();
        return;
    }
    const section = isMobile ? $(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER_MWEB) : $(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER);
    section.length > 0 && section.show();
    const renderedHtml = swig.render('_viewingTypeToggle', viewModel);
    const targetElement = $(Selectors.WRAPPER).length ? $(Selectors.WRAPPER) :
        $(Selectors.PLACEHOLDER).length ? $(Selectors.PLACEHOLDER) :
            isMobile ? $(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER_MWEB) :
                $(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER);
    if (targetElement.length > 0) {
        if (isMobile && targetElement.hasClass(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER_MWEB)) {
            targetElement.html(renderedHtml);
        }
        else {
            targetElement.replaceWith(renderedHtml);
        }
    }
    if (showTabs) {
        if (isMobile) {
            $(Selectors.VIEWING_TYPE_TOGGLE_WRAPPER_MWEB).toggleClass(Styles.MOBILE_TABS);
        }
        $(Selectors.BTNS).on('click', (e) => {
            const tab = $(e.currentTarget).data('tab');
            const onDemand = tab === MOPViewTypes.ON_DEMAND;
            let clickDetails = 'buy tickets';
            if (onDemand) {
                clickDetails = 'watch at home';
            }
            adobeLaunch.track({
                clickDetails: `movie | overview | ${clickDetails} tab click`,
                event: adobeLaunch.EventTypes.GENERIC_CLICK,
            });
            selectTab(tab);
            if (isMobile) {
                $('html, body').animate({
                    scrollTop: $(onDemand ? Selectors.ON_DEMAND_DETAILS : Selectors.IN_THEATERS_CONTAINER).offset().top - 122,
                }, 500);
            }
        });
        selectTab([currentTab, defaultTab, MOPViewTypes.IN_THEATERS]
            .find(tabOption => Object.values(MOPViewTypes).includes(tabOption)));
    }
    const sticky = $(isMobile ? Selectors.VIEWING_TYPE_TOGGLE_WRAPPER_MWEB : Selectors.VIEWING_TYPE_TOGGLE_STICKY);
    stickyObserver = new IntersectionObserver(([entry]) => {
        const isSticky = entry.isIntersecting;
        sticky.toggleClass(Styles.STICK_TOGGLE, isSticky);
    }, { threshold: 0, rootMargin: isMobile ? '-50px 0px -100% 0px' : '0px 0px -100% 0px' });
    stickyObserver.observe(sticky[0]);
}
module.exports = {
    init,
    getCurrentTab: () => currentTab,
};
export default module.exports;